import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { OrdersStateT, RequestStatus } from "types";

import { Store } from "store/defaultState";
import { instrumentsSelector } from "store/entities/market/selectors";

export const selectOrderState = (state: Store): OrdersStateT => state.trade.orders;

export const openOrdersSelector = (state: Store) => state.trade.orders.openOrders;
export const closedOrdersSelector = (state: Store) => state.trade.orders.closedOrders;

export const selectCreateOrderLoading = createDraftSafeSelector(selectOrderState, (state: OrdersStateT) =>
  [RequestStatus.Pending].includes(state.createOrderStatus)
);
export const selectCancelOrderLoading = createDraftSafeSelector(selectOrderState, (state: OrdersStateT) =>
  [RequestStatus.Pending].includes(state.cancelOrderStatus)
);

export const selectOpenOrders = createDraftSafeSelector(
  openOrdersSelector,
  instrumentsSelector,
  (openOrders, instruments) => {
    const parsedOrders = openOrders.map(order => {
      const orderInstrument = instruments.find(instrument => instrument.instrument_id === order.instrument_id);

      return {
        ...order,
        base_currency: orderInstrument?.base_currency,
        base_currency_id: orderInstrument?.base_currency_id,
        quote_currency: orderInstrument?.quote_currency,
        quote_currency_id: orderInstrument?.quote_currency_id,
      };
    });

    return parsedOrders;
  }
);

export const selectOpenOrdersLoading = createDraftSafeSelector(selectOrderState, (state: OrdersStateT) =>
  [RequestStatus.None, RequestStatus.Pending].includes(state.openOrdersStatus)
);

export const selectClosedOrders = createDraftSafeSelector(
  closedOrdersSelector,
  instrumentsSelector,
  (closedOrders, instruments) => {
    const parsedOrders = closedOrders.map(order => {
      const orderInstrument = instruments.find(instrument => instrument.instrument_id === order.instrument_id);

      return {
        ...order,
        base_currency: orderInstrument?.base_currency,
        base_currency_id: orderInstrument?.base_currency_id,
        quote_currency: orderInstrument?.quote_currency,
        quote_currency_id: orderInstrument?.quote_currency_id,
      };
    });

    return parsedOrders;
  }
);

export const selectClosedOrdersLoading = createDraftSafeSelector(selectOrderState, (state: OrdersStateT) =>
  [RequestStatus.None, RequestStatus.Pending].includes(state.closedOrdersStatus)
);

export const selectCurrentHistoryPage = createDraftSafeSelector(
  selectOrderState,
  (state: OrdersStateT) => state.currentHistoryPage
);

export const selectClosedOrdersCount = createDraftSafeSelector(
  selectOrderState,
  (state: OrdersStateT) => state.closedOrdersCount
);